import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  GET_SAMPLE: `${SLICE_NAME}/get_sample`,
  CREATE_SAMPLE: `${SLICE_NAME}/create_sample`,
  UPDATE_SAMPLE: `${SLICE_NAME}/update_sample`,
  DELETE_SAMPLE: `${SLICE_NAME}/delete_sample`,
  GET_MANY_SAMPLES: `${SLICE_NAME}/get_many_samples`,
  GET_MANY_SAMPLES_BY_ID: `${SLICE_NAME}/get_many_samples_by_id`,
  GET_MANY_SAMPLES_BY_LOINC: `${SLICE_NAME}/GET_MANY_SAMPLES_BY_LOINC`,
  CUSTOM_REQUEST: `${SLICE_NAME}/custom_request`,
  PLACE_CUSTOM_REQUEST: `${SLICE_NAME}/place_custom_request`,
  IMPORT_SAMPLES: `${SLICE_NAME}/import_samples`,
  EXPORT_SAMPLES: `${SLICE_NAME}/export_samples`,
  SET_PRICE: `${SLICE_NAME}/set_price`,
} as const;
